import { useState } from "react";
import { Link } from "react-router-dom";

import { useServerData } from "@hooks";
import Logo from "@assets/images/logo-x.png";

const Nav = () => {
  const [navMenuOpen, setNavMenuOpen] = useState(false);
  const { signedIn } = useServerData();

  const closeMobileNav = () => {
    setNavMenuOpen(false);
  };

  const renderSignedInLinks = () => {
    if (!signedIn) return;

    return (
      <>
        <Link to="/team_member/new">New Team Member</Link>
        <a href="/users/sign_out" data-method="delete">
          Sign Out
        </a>
      </>
    );
  };

  return (
    <nav>
      <div className="left">
        <h1>
          <Link to="/" aria-label="EXSELLence Team Realty Inc. Brokerage">
            <span>E</span>
            <img src={Logo} />
            <span>SELLence</span>
          </Link>
        </h1>
      </div>

      <button
        id="nav-button"
        name="open-mobile-navigation-button"
        title="Mobile navigation menu button"
        onClick={() => setNavMenuOpen(!navMenuOpen)}
      >
        <i className={`fa ${navMenuOpen ? "fa-times" : "fa-bars"}`} aria-hidden="true" />
      </button>

      <div
        className={`right ${signedIn ? "signed-in" : ""} ${navMenuOpen ? "display-flex" : ""}`}
        id="mobile-menu"
      >
        <Link to="/mls_listings">MLS Listings</Link>
        <a onClick={closeMobileNav} href="/#team-container">
          Our Team
        </a>
        <a onClick={closeMobileNav} href="/#listings-container">
          Our Listings
        </a>
        <a onClick={closeMobileNav} href="/#contact-container">
          Contact
        </a>

        {renderSignedInLinks()}
      </div>
    </nav>
  );
};

export { Nav };
